import { OWN_HOME_DOWN_PAYMENT_SAVING } from "web_myplann/Inspiration/constants";

export const getDownPaymentYears = (gap: number) =>
	Math.max(1, Math.ceil(gap / OWN_HOME_DOWN_PAYMENT_SAVING / 12));
